import { createContext, useContext } from "react";

export interface SharedDragAndDropState {
    DraggableContent?: React.FC;
    isDragging: boolean;
    isDropped: boolean;
}

export const defaultSharedDragAndDropState: SharedDragAndDropState = {
    isDragging: false,
    isDropped: false,
};

export const SharedDragAndDropContext = createContext<SharedDragAndDropState>(
    defaultSharedDragAndDropState
);

export const useSharedDragAndDropContext = () =>
    useContext(SharedDragAndDropContext);
